import type { AdjustPlatform } from "./platform";

/**
 * プラットフォーム別 Adjust イベントトークン。
 * 定義されていないイベント・プラットフォームの組み合わせは送信しない（ホワイトリスト方式）。
 */
export const ADJUST_TOKENS: Record<
  string,
  Partial<Record<AdjustPlatform, string>>
> = {
  sign_up: {
    RenkaAndroid: "x3qjkl",
    HokageIos: "ydkl5l",
    CarinaIos: "b1bdtp",
    SakuraIos: "orzovn",
  },
  edit_profile: {
    RenkaAndroid: "74pbz6",
    HokageIos: "fiverv",
    CarinaIos: "5qboys",
    SakuraIos: "dwituj",
  },
  COMPLETE_SEND_MESSAGE: {
    RenkaAndroid: "su7ub9",
    HokageIos: "k49iu2",
    CarinaIos: "n7h9uy",
    SakuraIos: "bnpxzd",
  },
  COMPLETE_SEND_ONE_TAP_MESSAGE_FROM_BOARD: {
    RenkaAndroid: "jr9d8f",
    HokageIos: "dmcuyy",
    CarinaIos: "p0i25a",
    SakuraIos: "5poajo",
  },
  COMPLETE_SEND_FREE_MESSAGE_FROM_BOARD: {
    RenkaAndroid: "lqe0e4",
    HokageIos: "t0zq52",
    CarinaIos: "vaqp17",
    SakuraIos: "ugfsby",
  },
  SEND_GOOD: {
    RenkaAndroid: "bxgz31",
    HokageIos: "97zzxy",
    CarinaIos: "pmnewf",
    SakuraIos: "71yu13",
  },
  START_VIDEO_CALL: {
    RenkaAndroid: "7fapxn",
    HokageIos: "p3s6hl",
    CarinaIos: "2rmijo",
    SakuraIos: "hni7zu",
  },
  START_VIDEO_CHAT: {
    RenkaAndroid: "9vnh8e",
    HokageIos: "79sddh",
    CarinaIos: "1b7gp2",
    SakuraIos: "8mav3l",
  },
  START_VOICE_CALL: {
    RenkaAndroid: "3dglom",
    HokageIos: "xj43uw",
    CarinaIos: "phchwa",
    SakuraIos: "2cric4",
  },
  COMPLETE_BUY_VIDEO: {
    RenkaAndroid: "50iu1f",
    HokageIos: "yn9fqs",
    CarinaIos: "rm373z",
    SakuraIos: "x3kgyb",
  },
  COMPLETE_BUY_IMAGE: {
    RenkaAndroid: "789ltc",
    HokageIos: "toq8eh",
    CarinaIos: "uvj2yi",
    SakuraIos: "uyonmu",
  },
  COMPLETE_SEND_GIFT: {
    RenkaAndroid: "5c3bs0",
    HokageIos: "mcs1po",
    CarinaIos: "w0biwx",
    SakuraIos: "gzxzqj",
  },
  COMPLETE_SEND_STAMP: {
    RenkaAndroid: "22cxw5",
    HokageIos: "idzhwu",
    CarinaIos: "9qwksp",
    SakuraIos: "yyw9fi",
  },
  use_signup_point: {
    RenkaAndroid: "uorvou",
    HokageIos: "li2i9u",
    CarinaIos: "hgzjw1",
    SakuraIos: "85zwfy",
  },
  SEND_LOVENSE_IN_VIDEO_CALL: {
    SakuraIos: "xznuk4",
  },
  SEND_LOVENSE_IN_VIDEO_CHAT: {
    SakuraIos: "rcjilf",
  },
};

export const getAdjustToken = (
  eventName: string,
  platform: AdjustPlatform,
): string | undefined => {
  return ADJUST_TOKENS[eventName]?.[platform];
};
